import { render, staticRenderFns } from "./fiscal-juridico-solicitacoes.vue?vue&type=template&id=2a1fd504&"
import script from "./fiscal-juridico-solicitacoes.vue?vue&type=script&lang=js&"
export * from "./fiscal-juridico-solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./fiscal-juridico-solicitacoes.vue?vue&type=style&index=0&id=2a1fd504&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports